import { api } from '../../lib/api.ts';

export interface NotifRow {
  id: string;
  type: string;
  title: string;
  body: string;
  link: string | null;
  isRead: boolean;
  createdAt: string;
}

export const notificationsApi = {
  list: (page = 1, pageSize = 20) =>
    api.get<{ items: NotifRow[]; total: number; page: number; pageSize: number }>('/notifications', { params: { page, pageSize } })
      .then((r) => r.data),
  markRead: (id: string) => api.post(`/notifications/${id}/read`).then((r) => r.status),
  markAllRead: () => api.post('/notifications/read-all').then((r) => r.status),
};
